module.exports = __webpack_public_path__ + "img/AboutUs.c1c2696f.jpeg";